/**
 * The `offer-service` provides a [promotion type](https://github.com/RedTecLab/offer-service/blob/0055b9d0682051b17184c810c1f769a752732b1d/src/main/java/com/redteclab/offer/model/OfferPromotion.java#L9) as a `string`.
 * For known values, we define this enum-like object for better type safety.
 */
export const OFFER_PROMOTION_TYPE = {
  BUNDLE: 'bundle',
  FREEBIE: 'freebie',
  ONE_FOR_ONE: 'oneforone',
  ONE_PLUS_ONE: '1+1',
} as const

export type OFFER_PROMOTION_TYPE =
  (typeof OFFER_PROMOTION_TYPE)[keyof typeof OFFER_PROMOTION_TYPE]
